import axios from "axios";
import sdkSetting from "../../utils/SdkSetting.json";
// const version = require('../../utils/versionCheck');
// version.init();

class ProjectStore {
  constructor() {
    this.state = {
      title: "",
      gnb_design: {
        // logo: 'version.setting.set_favicon',
        // logo: 'imqa',
        logo: "",
        logo_width: 81,
        logo_height: 39,
        project_list_bg_color: "#f6f7fa",
      },
      projectListViewList: [],
      projectCardViewList: [],
      modalProjectList: [],
      teamList: [],
      selectedTeamId: 0,
      selectedTeamName: "(default)",
      isProjectLoading: false,
      isProjectDeleting: false,
      isModalLoading: false,
      createdKeyValue: "",
      createdPIdValue: "",
      pagination: {
        count: 1,
        maxPage: 1,
        isMoreBtn: false,
        order_by: "project_name",
        sort: "asc",
      },
      sdkOption: sdkSetting
    };

    this.mutations = {
      setProjectList(state, payload) {
        // state.project.projectList = payload;
        state.project.projectCardViewList = payload;
      },
      setModalProjectList(state, payload) {
        state.project.modalProjectList = payload;
      },
      setAddProjectList(state, payload) {
        // state.project.projectList = payload;
        state.project.projectListViewList = payload;
      },
      setTeamList(state, payload) {
        state.project.teamList = payload;
      },
      setSelectedTeamId(state, payload) {
        state.project.selectedTeamId = payload;
      },
      setSelectedTeamName(state, payload) {
        state.project.selectedTeamName = payload;
      },
      setCreatedKeyValue(state, payload) {
        state.project.createdKeyValue = payload;
      },
      setCreatedPIdValue(state, payload) {
        state.project.createdPIdValue = payload;
      },
      setIsProjectDeleting(state, payload) {
        state.project.isProjectDeleting = payload;
      },
      setIsModalLoading(state, payload) {
        state.project.isModalLoading = payload;
      },
      setGnbDesign(state, payload) {
        switch (payload) {
          case "amore":
            state.project.title = "B2C 모니터링 모바일";
            state.project.gnb_design.logo = "amore";
            state.project.gnb_design.logo_width = 210;
            state.project.gnb_design.logo_height = 32;
            state.project.gnb_design.project_list_bg_color = "#FCFDFF";

            state.project.gnb_design.project_team_bg_color = "#373e57";

            state.project.gnb_design.project_team_create_box_src =
              "url(/../img/icon-team-white-off.svg)";
            state.project.gnb_design.project_team_create_box_bg_color =
              "#373e57";
            state.project.gnb_design.project_team_create_box_border =
              "rgba(255, 255, 255, 0.2)";
            state.project.gnb_design.project_team_create_box_color = "#ffffff";
            state.project.gnb_design.project_team_create_box_hover_src =
              "url(/../img/icon-team-white-off.svg)";
            state.project.gnb_design.project_team_create_box_hover_bg_color =
              "#373e57";
            state.project.gnb_design.project_team_create_box_hover_border =
              "rgba(255, 255, 255, 0.2)";
            state.project.gnb_design.project_team_create_box_hover_color =
              "#ffffff";

            state.project.gnb_design.project_team_item_src =
              "/../img/ico-project-g-white-off.svg";
            state.project.gnb_design.project_team_item_bg_color = "#50576e";
            state.project.gnb_design.project_team_item_border = "none";
            state.project.gnb_design.project_team_item_color = "#ffffff";
            state.project.gnb_design.project_team_item_select_src =
              "/../img/ico-project-g-on.svg";
            state.project.gnb_design.project_team_item_select_bg_color =
              "#ffffff";
            state.project.gnb_design.project_team_item_select_border = "none";
            state.project.gnb_design.project_team_item_select_color = "#000000";

            break;
          default:
            state.project.title = "IMQA";
            state.project.gnb_design.logo = "imqa";
            state.project.gnb_design.logo_width = 81;
            state.project.gnb_design.logo_height = 39;
            state.project.gnb_design.project_list_bg_color = "#f6f7fa";

            state.project.gnb_design.project_team_bg_color = "#ffffff";

            state.project.gnb_design.project_team_create_box_src =
              "url(/../img/icon-team-off.svg)";
            state.project.gnb_design.project_team_create_box_bg_color =
              "#eeeeee";
            state.project.gnb_design.project_team_create_box_border = "#eeeeee";
            state.project.gnb_design.project_team_create_box_color = "#5d5d5d";
            state.project.gnb_design.project_team_create_box_hover_src =
              "url(/../img/icon-team-on.svg)";
            state.project.gnb_design.project_team_create_box_hover_bg_color =
              "#efeeff";
            state.project.gnb_design.project_team_create_box_hover_border =
              "#dcdaf9";
            state.project.gnb_design.project_team_create_box_hover_color =
              "#2c396c";

            state.project.gnb_design.project_team_item_src =
              "/../img/ico-project-g-off.svg";
            state.project.gnb_design.project_team_item_bg_color = "#ffffff";
            state.project.gnb_design.project_team_item_border = "#dededf";
            state.project.gnb_design.project_team_item_color = "#2c396c";
            state.project.gnb_design.project_team_item_select_src =
              "/../img/ico-project-g-on.svg";
            state.project.gnb_design.project_team_item_select_bg_color =
              "#efeeff";
            state.project.gnb_design.project_team_item_select_border =
              "#dcdaf9";
            state.project.gnb_design.project_team_item_select_color = "#2c396c";
            break;
        }
      },
    };

    this.getters = {
      getTitle(state /*getters*/) {
        return state.project.title;
      },
      getGnbDesign(state /*getters*/) {
        return state.project.gnb_design;
      },
      getHasPaid(state /*getters*/) {
        return state.project.paidProjectCount > 0;
      },
    };

    this.actions = {
      getProjectList({ commit, state }) {
        // piad 프로젝트 개수 초기화
        state.project.paidProjectCount = 0;
        setTimeout(() => {
          state.project.isProjectLoading = true;
          let api = "";
          const selectedTeamId = state.project.selectedTeamId;
          const selectedTeamName = state.project.selectedTeamName;
          const query = {
            timezone: state.timezone,
            type: state.view_mode,
            page: state.project.pagination.count,
            project_id: state.project.createdPIdValue,
            order_by: state.project.pagination.order_by,
            sort: state.project.pagination.sort,
          };

          if (state.project.createdPIdValue === "") {
            delete query.project_id;
          } else {
            state.project.pagination.count = 1;
            query.page = 1;
          }

          if (state.view_mode === "card") {
            delete query.page;
          }

          if (selectedTeamId) {
            api = `/api/project/list/${selectedTeamId}`;
          } else {
            api = "/api/project/list";
          }
          window.sessionStorage.setItem(
            "team",
            JSON.stringify({ id: selectedTeamId, name: selectedTeamName })
          );

          axios.get(api, { params: query }).then((result) => {
            const project_list = [];
            for (const project of result.data.project_list) {
              project[`service_${project.service}`] = true;
              delete project.service;

              project.icon_type =
                project.screen_type === "reactnative"
                  ? "reactnative"
                  : project.platform;

              //방금 생성한 프로젝트를 펼침상태로 세팅
              if (state.project.createdPIdValue === project.project_id) {
                project.contentVisible = true;
              } else {
                project.contentVisible = false;
              }

              if (
                project_list.length > 0 &&
                project_list[project_list.length - 1].project_id ===
                  project.project_id
              ) {
                if (project.platform === "web") {
                  project_list[project_list.length - 1].service_wpm = true;
                  project_list[project_list.length - 1].service_wcrash = true;
                } else {
                  project_list[project_list.length - 1].service_mpm = true;
                  project_list[project_list.length - 1].service_crash = true;
                }
              } else {
                project_list.push(project);
              }
            }

            // commit('project/setProjectList', result.data.project_list);
            // if(state.view_mode == 'list' && state.project.pagination.count > 1){ //get more project lists
            if (state.view_mode === "list") {
              //get more project lists
              if (state.project.pagination.count > 1) {
                commit(
                  "project/setAddProjectList",
                  state.project.projectListViewList.concat(project_list)
                );
              } else {
                commit("project/setAddProjectList", project_list);
              }
              state.project.pagination.isMoreBtn = result.data.is_more_btn;
              state.project.pagination.maxPage = result.data.max_page;
            } else {
              commit("project/setProjectList", project_list);
            }
            state.project.isProjectLoading = false;
          });
        }, 500);
      },
      getTeamList({ commit }) {
        setTimeout(() => {
          axios.get("/api/team/list").then((res) => {
            commit("project/setTeamList", res.data);
          });
        }, 0);
      },
      getModalProjectList({ commit, state }) {
        return new Promise((resolve, reject) => {
          const time = state.timezone === "" ? 700 : 0;

          setTimeout(() => {
            const query = {
              timezone: state.timezone,
              type: "card",
              order_by: state.project.pagination.order_by,
            };

            axios.get("/api/project/list", { params: query }).then((result) => {
              const project_list = [];
              for (const project of result.data.project_list) {
                if (
                  project_list.length > 0 &&
                  project_list[project_list.length - 1].project_id ===
                    project.project_id
                ) {
                  project_list[project_list.length - 1].service_mpm = true;
                  project_list[project_list.length - 1].service_crash = true;
                } else {
                  if (project.platform != "web") project_list.push(project);
                }
              }
              commit("project/setModalProjectList", project_list);
              resolve();
            });
          }, time);
        });
      },
    };
  }
}

export default new ProjectStore();
